/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, memo, useMemo } from "react";
import useStyles from "../../../../styles";
import ProductItem from "components/ProductItem";
import ProductItemLoading from "components/ProductItemLoading";
import InfiniteScroll from "react-infinite-scroll-component";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CircularProgress from "@material-ui/core/CircularProgress";

import { Grid, Button } from "@material-ui/core";
import { HEIGHT_FOOTER } from "config/constant";
import { getUniqueProductIds, configDataProduct } from "utils/utils";

const ButtonExpand = memo(props => {
	const classes = useStyles();
	const [isExpand, setIsExpand] = useState(false);
	const { handleExpandLess, handleExpandMore } = props;
	const handleButton = () => {
		if (isExpand) {
			handleExpandMore();
		} else {
			handleExpandLess();
		}
		setIsExpand(!isExpand);
	};

	return (
		<Button
			color="primary"
			onClick={handleButton}
			classes={{ root: classes.btnScrollProduct }}
		>
			{isExpand ? <ExpandMoreIcon /> : <ExpandLessIcon />}
		</Button>
	);
});

const HEIGHT_FULL_PRODUCT = 152;
const NUMBER_PRODUCT_MORE = 18;
const NUMBER_PRODUCT_LESS = 10;

const HomeProductListLoadMore = props => {
	const classes = useStyles();
	const {
		refProductListScroll,
		products,
		business,
		isPull,
		totalListProduct,
		getListProduct,
		carts,
		updateChangeListProduct,
		setHeightProductsScroll
	} = props;

	const [allProduct, setAllProduct] = useState([]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(1);
	const [heightListProduct, setHeightListProduct] = useState("");

	const divFirstToScrollTo = document.getElementById("firtsHome");
	const divToScrollTo = document.getElementById("refProductListScroll");
	const distanceProductToTop = divToScrollTo?.offsetTop;

	const countProduct =
		heightListProduct === HEIGHT_FULL_PRODUCT
			? NUMBER_PRODUCT_MORE
			: NUMBER_PRODUCT_LESS;

	useEffect(() => {
		if (distanceProductToTop) {
			const height = HEIGHT_FOOTER + distanceProductToTop;
			setHeightListProduct(height);
		}
	}, [distanceProductToTop]);

	useEffect(() => {
		if (!products) {
			return;
		}
		const tempsProduct = getUniqueProductIds([...allProduct, ...products]);
		const allList = configDataProduct(tempsProduct, carts);
		setAllProduct(allList);
	}, [products]);

	const fetchMoreData = () => {
		if (
			allProduct.length >= totalListProduct ||
			page * countProduct >= totalListProduct
		) {
			setHasMore(false);
			return;
		}
		setPage(prevPage => prevPage + 1);
		const data = {
			keyword: "",
			requirePrice: true,
			business: business,
			count: countProduct,
			offset: page * countProduct
		};
		getListProduct(data);
	};

	useEffect(() => {
		setAllProduct([]);
		const data = {
			keyword: "",
			requirePrice: true,
			business: business,
			count: countProduct,
			offset: 0
		};
		getListProduct(data);
	}, []);

	const hidden = useMemo(() => (!isPull ? "scroll" : "hidden"), [isPull]);

	const handleExpandLess = async () => {
		await setHeightListProduct(152);
		await divToScrollTo.scrollIntoView({
			behavior: "smooth",
			block: "start"
		});
	};

	const handleExpandMore = async () => {
		const height = HEIGHT_FOOTER + distanceProductToTop;
		setHeightListProduct(height);
		await setHeightListProduct(height);
		await divFirstToScrollTo.scrollIntoView({
			behavior: "smooth",
			block: "start"
		});
	};

	const onScroll = event => {
		const position = event.target.scrollTop;
		setHeightProductsScroll(position);
	};

	return (
		<React.Fragment>
			<Grid classes={{ root: classes.rootTitle }}>
				<Grid classes={{ root: classes.title }}>Tất cả sản phẩm</Grid>
				<ButtonExpand
					handleExpandLess={handleExpandLess}
					handleExpandMore={handleExpandMore}
				/>
			</Grid>
			<div ref={refProductListScroll} id="refProductListScroll" />
			<Grid
				style={{
					height: `calc(100vh - ${heightListProduct}px)`
				}}
				classes={{ root: classes.infiniteScroll }}
			>
				<InfiniteScroll
					dataLength={allProduct.length}
					next={fetchMoreData}
					hasMore={hasMore}
					height={`calc(100vh - ${heightListProduct}px)`}
					scrollThreshold={0.5}
					onScroll={onScroll}
					style={{ padding: "0px 16px", overflow: hidden }}
					loader={
						<Grid
							onClick={fetchMoreData}
							style={{
								display: "flex",
								justifyContent: "center",
								marginBottom: 5
							}}
						>
							<CircularProgress
								thickness={4}
								style={{ height: 25, width: 25 }}
							/>
						</Grid>
					}
				>
					{allProduct.length > 0 ? (
						allProduct.map((product, index) => (
							<ProductItem
								product={product}
								key={index}
								updateChangeListProduct={
									updateChangeListProduct
								}
								products={allProduct}
								carts={carts}
							/>
						))
					) : (
						<ProductItemLoading />
					)}
					{carts.length > 0 && <div style={{ height: 70 }} />}
				</InfiniteScroll>
			</Grid>
		</React.Fragment>
	);
};

export default memo(HomeProductListLoadMore);
